import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BackofficeHero from './components/BackofficeHero';
import QuickAccessCards from './components/QuickAccessCards';
import { useSEO } from '../../utils/seo';

export default function Backoffice() {
  useSEO({
    title: 'Agent Backoffice | Jeffery Long - eXp Realty',
    description: 'Internal agent backoffice portal for Jeffery Long eXp Realty team.',
    noIndex: true,
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <BackofficeHero />
        <QuickAccessCards />
      </main>
      <Footer />
    </div>
  );
}
